export type LabelChipProps = {
    text?: string,
    mainClass?: string
}

export enum LabelChipClassType {
    Primary = "labelChip-primary",
    Secondary = "labelChip-secondary",
    Checkbox = "collective-label-checkbox"
}